var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-empty',{staticClass:"base_empty",attrs:{"description":_vm.desc},scopedSlots:_vm._u([{key:"image",fn:function(){return [_c('img',{staticClass:"empty_img",attrs:{"src":_vm.icons[_vm.icon],"alt":_vm.desc,"title":_vm.desc}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }